import styled from 'styled-components';
export const Container = styled.div `
    background-color: ${(props) => props.backgroundColor};
    color: ${(props) => props.textColor};
    text-align: ${(props) => props.$layout.align.toLowerCase()};

    --text-k-primary: ${(props) => props.textColor};
    --bg-k-primary: ${(props) => props.backgroundColor};
    --border-k-primary: ${(props) => props.textColor + '4c'};

    h1,
    h2,
    h3,
    h4,
    h5 {
        font-family: 'Poppins', sans-serif;
        font-style: normal;
    }
    /* H1-Poppins-Semibold */
    h1 {
        font-weight: 600;
        font-size: 2.5rem;
        line-height: 3rem;
    }
    /* H2-Poppins-Semibold */
    h2 {
        font-weight: 600;
        font-size: 2rem;
        line-height: 2.5rem;
    }
    /* H3-Poppins-Semibold */
    h3 {
        font-weight: 600;
        font-size: 1.5rem;
        line-height: 2rem;
    }
    /* H4-Poppins-Semibold */
    h4 {
        font-weight: 600;
        font-size: 1.125rem;
        line-height: 1.5rem;
    }
    /* H5-Poppins-Regular */
    h5 {
        font-weight: 400;
        font-size: 1.125rem;
        line-height: 1.5rem;
    }
    /* H5-Poppins-Semibold */
    h5.semibold {
        font-weight: 600;
    }
    /* Tittle-Poppins-Semibold */
    h6 {
        font-family: Inter;
        font-style: normal;
        font-weight: bold;
        font-size: 0.875rem;
        line-height: 1rem;
    }
    /* Text-Inter-Regular */
    p {
        font-family: 'Inter', sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 0.875rem;
        line-height: 1.25rem;
    }

    a {
        text-decoration: none;
        :visited,
        :hover,
        :active {
            color: unset;
        }
    }
`;
